import React from "react";

const steps = [
  {
    title: "Register as a supply partner",
    detail:
      "Getting started is easy. We’ll ask for some simple contact and company details, such as which travel experiences your business offers",
  },
  {
    title: "Share your business details",
    detail:
      "From there, you’ll fill out your key legal and financial information",
  },
  {
    title: "Add your first activity",
    detail:
      "Create and upload your first product listing with your content, availability, and reservation system connection",
  },
];

function HomeCTASection() {
  const handleGetStarted = () => {};
  return (
    <div className={Classname.container}>
      <div className={Classname.content}>
        <div className="bg-[#EBEFF959] w-full p-10 max-w-4xl rounded-lg flex flex-col items-center">
          <span className="text-center font-bold text-lg lg:text-xl mb-4 lg:mb-10">
            Ready to grow your travel business? Get started today.
          </span>
          <button
            className="h-14 w-full lg:w-80 bg-primary rounded-md flex items-center justify-center text-white text-sm lg:text-base font-bold"
            onClick={handleGetStarted}
          >
            Get Started
          </button>
        </div>
      </div>
    </div>
  );
}

export default HomeCTASection;

const Classname = {
  container:
    "w-full flex justify-center pt-20 px-basicx xl:px-0 font-main relative mb-20",
  content: "w-full flex flex-col max-w-7xl px-2 xl:px-0 items-center",
  title:
    "text-primary text-lg lg:text-xl font-bold  text-center lg:text-start max-w-56",
  description: "text-sm lg:text-base text-center lg:text-start",
  why: "flex flex-1 flex-col gap-4 items-center lg:items-start",
};
